import type { SurveyAnswerRecord } from '@coorum-research/shared-common/types/answer.type'
import type { SurveyElementJson } from '@coorum-research/shared-common/types/survey-json.type'

/**
 * 一度回答し、currentSurveyDataAtomに保存されたデータでも
 * 戻ってから、分岐のよってjumpした場合に、過去の回答データが残っている場合がある。
 * その場合、踏んでいない回答済みのデータを取り除く
 *
 * survey nameとanswerのkeyがが前方一致するものだけを残す
 * survey name(key) pattern
 * - 01J5WKGQJS1H7ESW1JRHQ32J9Y
 *
 * answer key pattern
 * - 01J5WKGQJS1H7ESW1JRHQ32J9Y (通常)
 * - 01J5WKGQJS1H7ESW1JRHQ32J9Y-Comment (コメント入力時)
 */
export function filterAnswerSkippedData(answeredSurveyData: SurveyAnswerRecord | null, surveyElements: SurveyElementJson[], answerPageIndexStack: number[]): SurveyAnswerRecord | null {
  if (!answeredSurveyData) {
    return null
  }

  const filteredSurveyData: SurveyAnswerRecord = {}
  const answeredElementNames = answerPageIndexStack.map((pageIndex) => {
    const element = surveyElements[pageIndex]
    // パネル内の要素も含める
    if (element.type === 'panel' && element.elements) {
      return [element.name, ...element.elements.map(e => e.name)]
    }
    return [element.name]
  }).flat()

  Object.keys(answeredSurveyData).forEach((key) => {
    // 前方一致で確認する
    if (answeredElementNames.some(elementName => key.startsWith(elementName))) {
      filteredSurveyData[key] = answeredSurveyData[key]
    }
  })

  // if empty object -> to null
  if (Object.keys(filteredSurveyData).length === 0) {
    return null
  }

  return filteredSurveyData
}
